__turbopack_context__.v({
  "selected": "SimpleAuthInputForm-module-scss-module__9y7FgW__selected",
  "sns_button": "SimpleAuthInputForm-module-scss-module__9y7FgW__sns_button",
});
